document.addEventListener("DOMContentLoaded", function () {
  const countryCodeDropdown = document.getElementById("countryCode");
  const phoneNumberInput = document.getElementById("phoneNumber");

  const phoneLengths = {
    "+91": 10,  // India
    "+1": 10,   // US & Canada
    "+44": 10,  // UK
    "+61": 9    // Australia
  };

  function updatePhoneNumber() {
    let selectedCode = countryCodeDropdown.value;
    let phoneValue = phoneNumberInput.value.replace(/^\+\d+\s?/, "").replace(/\D/g, ""); // Remove non-numeric characters
    let maxLength = phoneLengths[selectedCode] || 10;

    phoneValue = phoneValue.slice(0, maxLength); // Enforce max length

    phoneNumberInput.value = selectedCode + " " + phoneValue;

    setTimeout(() => {
      phoneNumberInput.selectionStart = phoneNumberInput.selectionEnd = phoneNumberInput.value.length;
    }, 10);
  }

  // Update phone number when country changes
  countryCodeDropdown.addEventListener("change", updatePhoneNumber);

  // Restrict input to numbers and enforce max length
  phoneNumberInput.addEventListener("input", function () {
    updatePhoneNumber();
  });

  // Prevent user from removing the country code manually
  phoneNumberInput.addEventListener("keydown", function (event) {
    let selectedCode = countryCodeDropdown.value;
    
    if (this.selectionStart <= selectedCode.length && event.key === "Backspace") {
      event.preventDefault();
    }
    
    if (event.key.match(/\D/) && !["Backspace", "ArrowLeft", "ArrowRight", "Tab"].includes(event.key)) {
      event.preventDefault();
    }
  });

  // Initial formatting
  updatePhoneNumber();
});
